var _jsxFileName = "/codebuild/output/src1718503544/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/settings/AccountInformation/AccountInfoMinor/index.tsx";
import React, { memo, useCallback, useEffect } from 'react';
import { IconClose, InformationalScreen, LoadingModal, Stack, Text } from '@adc/parallax-component-library';
import { LocalDate } from '@js-joda/core';
import { useFormik } from 'formik';
import parsePhoneNumberFromString from 'libphonenumber-js';
import * as Yup from 'yup';
import { BirthdayInput, Footer, FormContainer, Input, MainContainer, PhoneInput } from 'Components/utility';
import i18n from 'Utilities/i18n';
import log from 'Utilities/log';
const AccountInfoMinor = ({
  patient,
  firstNameLimit,
  lastNameLimit,
  loading,
  showPhoneInput,
  phoneErrorTimestamp,
  onSave,
  onBack,
  hasFormChanged,
  validateDOBAndDisplayError,
  validateEntriesLengthAndDisplayError
}) => {
  const validationMinorSchema = Yup.object().shape({
    firstName: Yup.string().required(i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.formField.firstName.errors.required')).trim(),
    lastName: Yup.string().required(i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.formField.lastName.errors.required')).trim(),
    dateOfBirth: Yup.string().required(i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.formField.dob.errors.required')),
    guardianFirstName: Yup.string().required(i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.firstName.errors.required')).trim(),
    guardianLastName: Yup.string().required(i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.lastName.errors.required')).trim(),
    phoneNumber: Yup.string().when('country', {
      is: () => showPhoneInput,
      then: Yup.string().required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber')).min(7, i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber')).test('test-valid-phone', i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber'), value => {
        var _parsePhoneNumberFrom;
        return ((_parsePhoneNumberFrom = parsePhoneNumberFromString(value ?? '', {
          extract: false
        })) === null || _parsePhoneNumberFrom === void 0 ? void 0 : _parsePhoneNumberFrom.isValid()) ?? false;
      }),
      otherwise: Yup.string().notRequired()
    })
  });
  const onSubmitForm = useCallback(async values => {
    if (!values.guardianFirstName || !values.guardianLastName) {
      return;
    }
    const isValid = validateEntriesLengthAndDisplayError([{
      value: values.firstName,
      msgKey: 'CreateAccountAccountInfo.modals.accountInfoErrors.validationRules.firstNameMaxLength',
      count: firstNameLimit
    }, {
      value: values.lastName,
      msgKey: 'CreateAccountAccountInfo.modals.accountInfoErrors.validationRules.lastNameMaxLength',
      count: lastNameLimit
    }, {
      value: values.guardianFirstName,
      msgKey: 'CreateAccountAccountInfo.modals.accountInfoErrors.validationRules.firstNameMaxLength',
      count: firstNameLimit
    }, {
      value: values.guardianLastName,
      msgKey: 'CreateAccountAccountInfo.modals.accountInfoErrors.validationRules.lastNameMaxLength',
      count: lastNameLimit
    }]);
    if (!isValid) {
      return;
    }
    try {
      onSave(values);
    } catch (err) {
      log.error(err);
    }
  }, [firstNameLimit, lastNameLimit, onSave, validateEntriesLengthAndDisplayError]);
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    isValid,
    isSubmitting,
    errors,
    touched,
    values,
    initialValues
  } = useFormik({
    initialValues: patient,
    validationSchema: validationMinorSchema,
    onSubmit: onSubmitForm,
    validateOnBlur: true
  });
  const handleOnBack = useCallback(() => {
    onBack(initialValues, values);
  }, [initialValues, values, onBack]);
  useEffect(() => {
    setFieldError('phoneNumber', i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.enterDifferentNumber'));
  }, [phoneErrorTimestamp, setFieldError]);
  return /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 195,
      columnNumber: 5
    }
  }, loading && /*#__PURE__*/React.createElement(LoadingModal, {
    "aria-label": "Loading",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 196,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(InformationalScreen, {
    topNavigationProps: {
      title: i18n.t('AccountInformationPersonalInfo.title'),
      buttonStart: {
        element: /*#__PURE__*/React.createElement(IconClose, {
          testID: "AccountInformationPersonalInfo.go-back",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 201,
            columnNumber: 22
          }
        }),
        onPress: handleOnBack
      },
      testID: 'AccountInformationPersonalInfo.title'
    },
    testID: "AccountInformationPersonalInfo",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 197,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Page, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 208,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 209,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    gap: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 210,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    paddingVertical: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 211,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.primaryText",
    nativeID: "AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.primaryText",
    type: "$bodySmall.medium",
    color: "$text.60",
    textTransform: "uppercase",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 212,
      columnNumber: 17
    }
  }, i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.primaryText'))), /*#__PURE__*/React.createElement(FormContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 224,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.formField.firstName.label'),
    placeholder: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.formField.firstName.placeholder'),
    label: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.formField.firstName.label'),
    testID: "firstName",
    inputMode: "text",
    errorMessage: errors.firstName,
    isInvalid: errors.firstName && touched.firstName ? true : false,
    value: values.firstName,
    onChangeText: handleChange('firstName'),
    onBlur: handleBlur('firstName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 225,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.formField.lastName.label'),
    placeholder: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.formField.lastName.placeholder'),
    label: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoFormMinor.formField.lastName.label'),
    testID: "lastName",
    inputMode: "text",
    errorMessage: errors.lastName,
    isInvalid: errors.lastName && touched.lastName ? true : false,
    value: values.lastName,
    onChangeText: handleChange('lastName'),
    onBlur: handleBlur('lastName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 243,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(BirthdayInput, {
    error: errors.dateOfBirth && touched.dateOfBirth ? true : false,
    errorMessage: errors.dateOfBirth,
    testID: "dateOfBirth",
    onPress: () => setFieldTouched('dateOfBirth'),
    initialDate: values.dateOfBirth ? LocalDate.parse(values.dateOfBirth) : undefined,
    onDateChange: date => {
      setFieldTouched('dateOfBirth');
      const dateString = date.toString();
      const isValid = validateDOBAndDisplayError(dateString);
      if (isValid) {
        setFieldValue('dateOfBirth', dateString);
      }
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 261,
      columnNumber: 17
    }
  }), showPhoneInput && /*#__PURE__*/React.createElement(PhoneInput, {
    "aria-label": i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    errorMessage: errors.phoneNumber,
    isInvalid: errors.phoneNumber && touched.phoneNumber ? true : false,
    testID: "phoneNumber",
    value: values.phoneNumber,
    onChangeText: handleChange('phoneNumber'),
    onBlur: handleBlur('phoneNumber'),
    maxLength: 15,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 279,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testID: "AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.primaryText",
    type: "$bodySmall.medium",
    color: "$text.60",
    textTransform: "uppercase",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 295,
      columnNumber: 17
    }
  }, i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.primaryText')), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.firstName.label'),
    placeholder: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.firstName.placeholder'),
    label: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.firstName.label'),
    testID: "guardianFirstName",
    inputMode: "text",
    errorMessage: errors.guardianFirstName,
    isInvalid: errors.guardianFirstName && touched.guardianFirstName ? true : false,
    value: values.guardianFirstName,
    onChangeText: handleChange('guardianFirstName'),
    onBlur: handleBlur('guardianFirstName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 305,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.lastName.label'),
    placeholder: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.lastName.placeholder'),
    label: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.lastName.label'),
    testID: "guardianLastName",
    inputMode: "text",
    errorMessage: errors.guardianLastName,
    isInvalid: errors.guardianLastName && touched.guardianLastName ? true : false,
    value: values.guardianLastName,
    onChangeText: handleChange('guardianLastName'),
    onBlur: handleBlur('guardianLastName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 323,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.country.label'),
    label: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.country.label'),
    testID: "country",
    inputMode: "text",
    value: i18n.t(`Global.microcopy.countries.${values.country}`),
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 341,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.emailAddress.label'),
    label: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.emailAddress.label'),
    testID: "email",
    inputMode: "text",
    value: values.email,
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 353,
      columnNumber: 17
    }
  })))), /*#__PURE__*/React.createElement(InformationalScreen.Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 368,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Footer, {
    buttonLabel: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.links.saveButton.label'),
    onButtonPress: handleSubmit,
    buttonTestID: "AccountInformationPersonalInfo.saveButton",
    disabled: !values.firstName || !values.lastName || !values.dateOfBirth || !values.guardianFirstName || !values.guardianLastName || !isValid || isSubmitting || !hasFormChanged(initialValues, values),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 369,
      columnNumber: 13
    }
  })))));
};
export default /*#__PURE__*/memo(AccountInfoMinor);